module.exports = "footer{\r\n    background-color: #373c3e;\r\n}"